import { Injectable } from '@angular/core';
import { MbiemriLloji } from '@core/enums/mbiemri.enums';
import { MbiemriFemerorForCreationDTO } from '@core/interfaces/dto/mbiemri-femeror-for-creation-dto.interface';

@Injectable({
  providedIn: 'root'
})
export class MbiemriFemerorService {

  constructor() { }

  getCreationDTO(mbiemriBaza: any) {
    const creationDTO: MbiemriFemerorForCreationDTO[] = [];

    let formArray: any[] = mbiemriBaza.mbiemriFemerorEmerMbiemer.concat(mbiemriBaza.mbiemriFemerorMbiemerEmer);

    for (var i = 0; i < formArray.length; i++) {
      const e = formArray[i];

      if (mbiemriBaza.llojiId == MbiemriLloji.Inyjshem && e.formaFjalesId != null)
        continue;

      creationDTO.push({
        trajtaId: e.trajtaId,
        numriId: e.numriId,
        rasaId: e.rasaId,
        renditjaId: e.renditjaId,
        formaFjalesId: e.formaFjalesId,
        pershkrimi: e.pershkrimi,
        radhitja: e.radhitja
      });
    }

    return creationDTO;
  }
}
